<template>
  <div>
      
        <div class="col-md-12">
            <h3>Log da Campanha</h3>
            <table id="relLog" ref='tabela' class="table display table-hover table-striped"  style="width: 100%">
                <thead></thead>
                <tbody></tbody>
                <tfoot></tfoot>
            </table>
        </div>
  </div>
</template>

<script>
export default {
    props:{
        filter: {
            type: String,
            default: ''
        }
    },
    data(){
        return {
            dt: null,
            val: this.filter
        }
    },
    watch:{
        filter: {
            handler: function(val){
                this.createTable()
            },
            deep: true
        }
    },
    methods:{
        createTable(){

            if (this.dt){
                $('#relLog').DataTable().destroy();
            }

            this.dt = $('#relLog').DataTable({
                ajax:{
                    url: '/marketing/log',
                    data: { param: this.filter },
                    dataSrc: ''
                },
                columns: [
                {
                    data: 'created_at',
                    class: 'tamanho',
                    title: 'Data da campanha',
                    render: (data) => {
                        if(!data) return ''
                        return moment(data).format('DD/MM/YYYY HH:mm:ss')
                    }
                },    
                {
                    data: 'nome_campanha',
                    class: 'tamanho',
                    title: 'Campanha'
                },
                {
                    data: 'telefone',
                    class: 'tamanho',
                    title: 'Telefone',
                    render: (data) => {
                        if(data.includes('@s.whatsapp.net')){
                            const phoneArr = data.split('@')
                            if(phoneArr.length){
                                return phoneArr[0]
                            } else {
                                return 'Telefone não identificado'
                            }
                        }
                        return data
                    }
                },
                {
                    data: 'name',
                    class: 'tamanho',
                    title: 'Cliente'
                },
                {
                    data: 'status',
                    class: 'tamanho',
                    width: '100px',
                    title: 'Status',
                    render: (data, type, row) => {
                        const newStatus = ['pending', 'sent', 'delivered', 'read', 'failed', 'deleted']
                        if(newStatus.includes(data)){
                            if(data === 'pending') return `<div title="${row.description || ''}" style="cursor: help"><i class="fas fa-clock-o" style="color: orange"></i> Pendente</div>`
                            if(data === 'sent') return `<div title="${row.description || ''}" style="cursor: help"><i class="fas fa-check  style="color: gray"></i> Enviada</div>`
                            if(data === 'delivered') return `<div title="${row.description || ''}" style="cursor: help"><i class="fas fa-check-square" style="color: dodgerblue"></i> Entregue</div>`
                            if(data === 'read') return `<div title="${row.description || ''}" style="cursor: help"><i class="fas fa-check-square" style="color: mediumseagreen"></i> Lida</div>`
                            if(data === 'failed') return `<div title="${row.description || ''}" style="cursor: help"><i class="fas fa-times" style="color: red"></i> Falha</div>`
                            if(data === 'deleted') return `<div title="${row.description || ''}" style="cursor: help"><i class="fas fa-trash  style="color: red"></i> Deletada</div>`
                        }
                        return data
                    }
                },
                {
                    data: 'updated_at',
                    class: 'tamanho',
                    title: 'Última atualização',
                    render: (data) => {
                        if(data){
                            return moment(data).format("DD/MM/YY [às] HH:mm")
                        }
                        return data
                    }
                },
            ]
            })


            this.dt.buttons('.dtUpdateButton').remove();
        }
    },
    mounted(){
        this.createTable();

    }

}
</script>

<style scoped>
.tamanho{
    width: 200px;
}
</style>